import { testimonials, siteStats } from '@/mocks/nav';

const principles = [
  {
    icon: 'ri-shield-check-line',
    title: '只做入口整理',
    desc: '本站不生产内容、不做二次转载，仅收录公开可访问的入口地址，把判断权交回给用户。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日巡检',
    desc: '系统与人工结合，每天核对收录地址的可用性，失效的及时下架，新的尽快补位。',
  },
  {
    icon: 'ri-stack-line',
    title: '分类克制',
    desc: '分类保持精简，避免为了数量堆砌标签，让每个主题都真的有关注人群。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '反馈优先',
    desc: '用户提交的纠错与推荐会优先处理，多数会在一个工作日内完成核验与更新。',
  },
];

export default function AboutSection() {
  return (
    <section
      id="about"
      className="scroll-mt-20 border-b border-background-200 bg-background-100 py-14 md:scroll-mt-24 md:py-20"
    >
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-secondary-600 md:text-sm">
              <i className="ri-information-line text-base" aria-hidden="true"></i>
              About Us
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">关于黑料导航</h2>
            <div className="mt-4 flex flex-col gap-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              <p>
                黑料导航诞生于一个很朴素的困扰：好看的入口总是散落在各处，收藏夹越存越乱，过段时间再点开，
                一半已经失效。于是我们决定做一件小事——把这些入口按主题整理好，并持续核对地址是否还能打开。
              </p>
              <p>
                我们把自己定位成「入口地图」而不是「内容平台」。你在这里看到的是分类、简介和直达地址，
                真正的内容仍然由各入口站点自己呈现。这样的好处是：更新更快、维护更轻，也不会替你筛选观点。
              </p>
              <p>
                坚持免费、坚持不加付费置顶，是本站最基础的原则。收录与否只看它是否值得被放进地图里。
              </p>
            </div>

            <dl className="mt-7 grid grid-cols-2 gap-3">
              {siteStats.map((item) => (
                <div key={item.label} className="rounded-lg border border-background-200 bg-background-50 px-4 py-4">
                  <dd className="font-heading text-xl font-bold text-primary-600 md:text-2xl">
                    {item.value}
                    <span className="ml-0.5 text-xs font-normal text-foreground-500">{item.suffix}</span>
                  </dd>
                  <dt className="mt-1 text-xs text-foreground-600 md:text-sm">{item.label}</dt>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-7">
            <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">内容原则</h3>
            <ul className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((item) => (
                <li key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-lg text-secondary-700">
                    <i className={item.icon} aria-hidden="true"></i>
                  </span>
                  <h4 className="mt-3 font-heading text-base font-bold text-foreground-950">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </li>
              ))}
            </ul>

            <h3 className="mt-8 font-heading text-lg font-bold text-foreground-950 md:text-xl">用户怎么说</h3>
            <ul className="mt-4 flex flex-col gap-4">
              {testimonials.map((item) => (
                <li
                  key={item.name}
                  className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <span className="h-12 w-12 flex-shrink-0 overflow-hidden rounded-full border border-background-200">
                    <img
                      src={item.avatar}
                      alt={`用户 ${item.name} 的头像插画`}
                      title={`黑料导航 用户口碑 ${item.name}`}
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                  <div className="flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="font-heading text-sm font-bold text-foreground-950">{item.name}</span>
                      <span className="rounded-full bg-background-200 px-2 py-0.5 text-[11px] text-foreground-600">
                        {item.role}
                      </span>
                      <span className="flex items-center gap-0.5 text-accent-600">
                        <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                        <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                        <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                        <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                        <i className="ri-star-half-fill text-sm" aria-hidden="true"></i>
                      </span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}